import { components, labelModes } from '@/utils'

import buttonFilter from '@/components/button/filter'
import filterDate from '@/components/filter/date'
import selectorOwner from '@/components/selector/owner'
import state from '@/components/services/url-shortener-settings/domains/commons/form/state'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'

function renderDateFilter(h) {
  return h(
    filterDate,
    {
      props: {
        value: this.proxy.createdAt,
        preset: this.proxy.createdAtPreset,
        presets: true,
        clearable: true,
        backendGeneration: 'nest'
      },
      on: {
        input: event => {
          this.proxy.createdAt = event
        },
        preset: event => {
          this.proxy.createdAtPreset = event
        }
      }
    }
  )
}

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.name,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.name`),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.name = event
        }
      }
    }
  )
}
function renderStateField(h) {
  return h(
    state,
    {
      props: {
        value: this.proxy.state
      },
      on: {
        input: event => {
          this.proxy.state = event
        }
      }
    }
  )
}
function renderOwnerField(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        labelMode: labelModes.hidden,
        dense: true

      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [
    renderNameField.call(this, h),
    renderStateField.call(this, h),
    renderOwnerField.call(this, h)
  ]
}

function renderButtonFilter(h) {
  return h(
    buttonFilter,
    {
      props: {
        value: this.proxy,
        defaultValue: this.defaultFilter
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    },
    renderFields.call(this, h)
  )
}

function renderContentByViewport(h) {
  if (this.viewport.breakpoint.lgUp) {
    return renderButtonFilter.call(this, h)
  } else {
    return h(
      'div',
      {
        class: 'grid grid-gap--8'
      },
      renderFields.call(this, h)
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-filter`
    },
    [
      renderDateFilter.call(this, h),
      renderContentByViewport.call(this, h)
    ]
  )
}
